import { EventBus } from "@/eventbus.js";
import { dropRight, cloneDeep } from "lodash";
import store from "./../index";

const state = {
  history: [],
};
const getters = {};
const mutations = {
  setHistory: (state, value) => {
    state.history = value;
  },
  addToHistory: (state, value) => {
    state.history.push(value);
  },
  removeLastFromHistory: (state) => {
    state.history = dropRight(state.history);
  },
};
const actions = {
  undo({ commit, state }) {
    if (state.history.length === 0) {
      return;
    }
    const changeToUndo = cloneDeep(state.history[state.history.length - 1]);
    commit("removeLastFromHistory");

    const resetTargetIndex = state.history
      .map((item) => item.type)
      .lastIndexOf(changeToUndo.type);
    const resetTarget = state.history[resetTargetIndex];

    if (!resetTarget) {
      //some specific, handcrafted edge cases
      switch (changeToUndo.type) {
        case "brain/modules/handleFilterChange":
          store.commit(
            "brain/modules/setFilters",
            store.state.brain.modules.initialFilters
          );

          EventBus.$emit("brain/modules/handleFilterChange", {
            addToHistory: false,
            data: store.state.brain.modules.initialFilters,
          });

          break;
        case "brain/drivers/handleFilterChange":
          store.commit(
            "brain/drivers/setFilters",
            store.state.brain.drivers.initialFilters
          );

          EventBus.$emit("brain/drivers/handleFilterChange", {
            addToHistory: false,
            data: store.state.brain.drivers.initialFilters,
          });

          break;
      }
    } else {
      EventBus.$emit(resetTarget.type, {
        addToHistory: false,
        data: resetTarget.payload.data,
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
